import classNames from 'classnames/bind';
import styles from './Dashboard.module.scss';

import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import dashboardApi from '~/apis/dashboard';
import { IOverview, IStatistic } from '~/utils/interface/dashboard';
import NearlyWarning from './components/DailyWarning';
import DevicesSummary from './components/DevicesSummary';
import FacilityDevice from './components/FacilityDevice';
import FacilitySummary from './components/FacilitySummary';
import MapBox from './components/MapBox';
import NewUsers from './components/NewUsers';
import ServiceStatus from './components/ServiceStatus';
import WarningDevices from './components/WarningDevices';
import WarningSection from './components/WarningSection';
import { handleApiError } from '~/utils/helper';

const cx = classNames.bind(styles);

const Dashboard = () => {
  const [overviewData, setOverviewData] = useState<IOverview | null>(null);
  const [statisticData, setStatisticData] = useState<IStatistic | null>(null);
  useEffect(() => {
    getOverviewData();
    getStatisticData();
  }, []);

  const getOverviewData = async () => {
    try {
      const response = await dashboardApi.getOverviewData();
      setOverviewData(response.data);
    } catch (error) {
      handleApiError(error);
    }
  };

  const getStatisticData = async () => {
    try {
      const response = await dashboardApi.getStatisticData();
      setStatisticData(response.data);
    } catch (error) {
      handleApiError(error);
    }
  };
  return (
    <Box>
      <Box className={cx('flex mt-[50px] lg:h-[400px] xl:h-[500px] justify-between', 'home-page')}>
        <DevicesSummary device={overviewData?.device ?? null} />
        <Box className={cx('flex flex-col justify-between xl:w-[25%] lg:-w-[28px] h-full', 'dashboard-widget')}>
          <WarningDevices device_warning={overviewData?.device_warning} />
          <FacilitySummary installation_location={overviewData?.installation_location} />
        </Box>
        <WarningSection />
      </Box>
      <Box className={cx('flex mt-[50px] lg:h-[400px] xl:h-[500px] justify-between', 'home-page')}>
        <MapBox />
        <NearlyWarning />
      </Box>
      <Box className={cx('flex mt-[50px] lg:h-[400px] xl:h-[500px] justify-between', 'home-page')}>
        <NewUsers newUsers={statisticData?.new_accounts ?? []} />
        <ServiceStatus serviceStatus={statisticData?.service_status} />
        <FacilityDevice supplierStatistic={statisticData?.supplier_statistic ?? []} />
      </Box>
    </Box>
  );
};

export default Dashboard;
